import { IBallFinal, BallFinalKinds, IPlayMetadata } from '@trackman/baseball-shared-components';

export class PlayRowMetrics {
  constructor(play: IPlayMetadata, ballFinals: IBallFinal[]) {
    if (play.pitchTag.ballFinalTrackId !== null) {
      const ballFinal = ballFinals.find((bf) => bf.trackId === play.pitchTag.ballFinalTrackId);

      if (ballFinal) {
        this.verticalReleaseAngle = ballFinal?.pitch?.release.verticalAngle;
        this.horizontalReleaseAngle = ballFinal?.pitch?.release.horizontalAngle;
        this.spinRate = ballFinal.start.spinRate;
        this.spinAxis = ballFinal.pitch?.movement?.spinAxis;
        this.extension = ballFinal?.pitch?.release.extension;
        this.verticalBreak = ballFinal.pitch?.movement?.vertical;
        this.horizontalBreak = ballFinal.pitch?.movement?.horizontal;
        this.releaseSpeed = ballFinal.start.speed;
        this.tilt = ballFinal.pitch?.movement?.spinAxis;
        this.releaseHeight = ballFinal.start?.position?.y;
        this.releaseSide = ballFinal?.start?.position && -ballFinal.start.position.z;
        this.inducedVerticalBreak = ballFinal.pitch?.movement?.inducedVertical;
        this.plateLocHeight = ballFinal.pitch?.location?.position?.y;
        this.plateLocSide = ballFinal.pitch?.location?.position?.z && -ballFinal.pitch.location.position.z;
      }
    }

    if (play.hitTag.ballFinalTrackId !== null) {
      const ballFinal = ballFinals.find((bf) => bf.trackId === play.hitTag.ballFinalTrackId);

      if (ballFinal) {
        this.hitExitSpeed = ballFinal.start?.speed;
        this.hitEstCarry = ballFinal.hit?.landingFlat?.distance;
        this.hitDirection = ballFinal.hit?.launch?.horizontalAngle;
        this.hitBearing = ballFinal.hit?.landingFlat?.bearing;
      }
    }
  }

  verticalReleaseAngle?: number;

  horizontalReleaseAngle?: number;

  spinRate?: number;

  spinAxis?: number;

  extension?: number;

  verticalBreak?: number;

  horizontalBreak?: number;

  releaseSpeed?: number;

  tilt?: number;

  releaseHeight?: number;

  releaseSide?: number;

  inducedVerticalBreak?: number;

  plateLocHeight?: number;

  plateLocSide?: number;

  hitExitSpeed?: number;

  hitEstCarry?: number;

  hitDirection?: number;

  hitBearing?: number;
}
